
import { faGift, faPawSimple } from '@fortawesome/pro-solid-svg-icons'

export default {
  name: 'Basket',

  props: {
    isTitleVisible: {
      type: Boolean,
      default: true
    },

    isCheckoutButtonVisible: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      basketApi: new this.$ApiModel(),
      faGift,
      faPawSimple
    }
  },

  computed: {
    compBasket() {
      return this.$store.getters['booking/getBasket']
    }
  },

  created() {
    this.$store.dispatch('booking/fetchBasket')
  },

  methods: {
    checkout() {
      if (this.$app.isBrochureware) {
        this.$modal.closeAll()
        this.$redirect.to('/book/checkout')
      } else {
        this.$redirect.to('/platform/book/checkout')
      }
    },

    async removeFromBasket(itemId, type) {
      try {
        if (type === 'booking') {
          const { response } = await this.$api.booking(this.basketApi).deleteBooking(itemId)

          this.$store.commit('booking/setBasket', { basket: response.data, checkForRemovals: false })
        } else if (type === 'voucher') {
          const { response } = await this.$api.discount(this.basketApi).removeVoucherFromBasket(itemId)

          this.$store.commit('booking/setBasket', { basket: response.data, checkForRemovals: false })
        }
      } catch (error) {
        this.$log.error('Error removing booking from basket', error)
        this.$notify.error('Error removing booking from basket, please reload and try again')
      }
    }
  }
}
